import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import CartDrawer from './components/CartDrawer';
import Home from './pages/Home';
import Candy from './pages/Candy';
import Apparel from './pages/Apparel';
import About from './pages/About';
import TheProduct from './pages/TheProduct';
import Contact from './pages/Contact';
import Community from './pages/Community';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

function CartDrawerWrapper() {
  const location = useLocation();
  if (location.pathname === '/admin') return null;
  return <CartDrawer />;
}

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Header />
        <CartDrawerWrapper />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/candy" element={<Candy />} />
          <Route path="/apparel" element={<Apparel />} />
          <Route path="/about" element={<About />} />
          <Route path="/the-product" element={<TheProduct />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reviews" element={<Community />} />
          <Route path="/community" element={<Community />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
